import { createFileRoute } from "@tanstack/react-router";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { LegalLayout } from "@/components/legal/LegalLayout";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";

export const Route = createFileRoute("/_main/termos-de-uso")({
  component: TermosDeUso,
});

function TermosDeUso() {
  const [pagina, setPagina] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPagina() {
      const { data } = await (supabase as any)
        .from("paginas_legais")
        .select("*")
        .eq("slug", "termos-de-uso")
        .eq("publicada", true)
        .single();
      
      if (data) setPagina(data);
      setLoading(false);
    }
    fetchPagina();
  }, []);

  if (loading) return null;

  const sections = [
    { id: "1", title: "1. Aceitação dos Termos" },
    { id: "2", title: "2. Natureza do Serviço" },
    { id: "3", title: "3. Uso Permitido" },
    { id: "4", title: "4. Limitação de Responsabilidade" },
    { id: "5", title: "5. Denúncias e Moderação" },
    { id: "6", title: "6. Alterações nos Termos" },
  ];

  return (
    <LegalLayout
      title={pagina?.titulo || "Termos de Uso"}
      lastUpdate={pagina?.versao || "8 de agosto de 2026"}
      sections={sections}
      canonical="https://spark-smile-hub.lovable.app/termos-de-uso"
      description="Termos de uso exclusivos para clientes da plataforma Gopage."
    >
      <div className="prose prose-slate max-w-none">
        <ReactMarkdown 
          remarkPlugins={[remarkGfm]} 
          rehypePlugins={[rehypeSanitize]}
        >
          {pagina?.conteudo || ""}
        </ReactMarkdown>
      </div>
    </LegalLayout>
  );
}
